import { CheckOutlined, RotateLeftOutlined } from '@ant-design/icons'

import {
  ActionEnum,
  leadsLogsListQueryKey,
  leadsTasksListQueryKey,
  ReturnLogsReadable,
  ReturnTaskReadable,
  tasksPartialUpdateMutation
} from '@crm/api'
import { CompleteTask } from '@crm/components/InfoTabs/Tabs'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { useMutation } from '@tanstack/react-query'
import { Button } from 'antd'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

type Props = {
  log: ReturnLogsReadable
}

export const CompleteTaskButton = ({ log }: Props) => {
  const { t } = useLocales()
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const [task, setTask] = useState<ReturnLogsReadable['task']>()
  const [undo, setUndo] = useState(false)
  const { id } = useParams()

  const isCompleted = Boolean(log?.task?.completed_at)

  const mutation = useMutation({
    ...tasksPartialUpdateMutation(),
    onSuccess: () => {
      invalidateQueries([
        leadsLogsListQueryKey({
          path: { lead_id: String(id) }
        }),
        leadsTasksListQueryKey({
          path: { lead_id: String(id) }
        })
      ])

      setUndo(false)
    }
  })

  const onUncompleteTask = () => {
    if (log?.task?.id) {
      mutation.mutate({
        path: { id: log.task.id },
        body: { completed_at: null }
      })
    }
  }

  if (log.action === ActionEnum.EXPIRED || log.action === ActionEnum.DELETED) {
    return (
      <Button size="small" disabled>
        {t(`logs.${log.action}`)}
      </Button>
    )
  }

  return (
    <>
      {undo ? (
        <Button
          size="small"
          type="primary"
          onClick={onUncompleteTask}
          icon={<RotateLeftOutlined />}
        >
          {t('task.undo')}
        </Button>
      ) : (
        <Button
          size="small"
          onClick={() => log?.task && setTask(log?.task)}
          icon={<CheckOutlined />}
          disabled={isCompleted}
        >
          {t(isCompleted ? 'task.completed_task' : 'task.complete_task')}
        </Button>
      )}

      {task && (
        <CompleteTask
          task={task as ReturnTaskReadable}
          onCancel={() => setTask(undefined)}
          open={!!task}
        />
      )}
    </>
  )
}
